export function getIsRatingItemFilled({ hoverValue, rating, value }) {
  return hoverValue ? value <= hoverValue : rating >= value
}
